import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { SidebarContext } from "../../contexts";

export const SidebarProvider = ({ children }: { children: ReactNode }) => {
    const location = useLocation();

    return (
        <SidebarContext.Provider value={{ activePath: location.pathname }}>
            {children}
        </SidebarContext.Provider>
    );
};